import axios from 'axios';

const API_URL = '/api/results-alignment';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const resultsAlignmentService = {
  /**
   * Generate potential results/outcomes
   */
  async generateResults() {
    try {
      const response = await axios.post(`${API_URL}/generate`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to generate results'
      };
    }
  },

  /**
   * Get saved results
   */
  async getResults() {
    try {
      const response = await axios.get(`${API_URL}/results`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get results'
      };
    }
  },

  /**
   * Save selected results
   */
  async saveResults(selectedResults) {
    try {
      const response = await axios.post(`${API_URL}/save`, {
        selected_results: selectedResults
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save results'
      };
    }
  }
};

export default resultsAlignmentService;
